mutation (
  $email: AWSEmail!
  $confirmationCode: String!
  $locale: Locale!
) {
  confirmSignUp(
    email: $email
    confirmationCode: $confirmationCode
    locale: $locale
  )
}
